<template>
  <el-dialog title="选择企业"
             :visible.sync="visible"
             width="600px"
             append-to-body=""
             @closed="handleClosed">
    <div class="search-form">
      <el-input placeholder="请输入企业名称"
                style="width: 200px"
                v-model="config.vendorName"
                class="input-with-select">
        <el-button slot="append"
                   icon="el-icon-search"
                   @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <el-table border
              max-height="400"
              v-loading="loading"
              highlight-current-row
              @row-click="handleCurrentRowChange"
              :data="list">
      <el-table-column label=""
                       width="50">
        <template slot-scope="{row}">
          <el-radio v-model="current.vendorId"
                    :label="row.vendorId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column label="企业名称"
                       prop='vendorName'></el-table-column>
      <el-table-column label="联系人"
                       prop='vendorPerson'></el-table-column>
    </el-table>
    <div slot="footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary"
                 @click="add">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'org-select-ent-modal',
  components: {},
  props: { callback: Function },
  data () {
    return {
      loading: false,
      visible: false,
      config: { pageNum: 1, pageSize: 10, vendorName: '' },
      list: [],
      total: 0,
      current: {}
    }
  },
  methods: {
    handleClosed () {
      this.list = []
      this.total = 0
      this.config.pageNum = 1
      this.config.vendorName = ''
      this.current = {}
    },
    handleCurrentChange (cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    add () {
      if (!this.current.vendorId) {
        this.$message.error('请选择一个企业')
        return
      }
      this.callback && this.callback(this.current)
      this.visible = false
    },
    handleCurrentRowChange (row) {
      console.log('handleCurrentRowChange', row)
      this.current = row || {}
    },
    fetchList (cb) {
      this.loading = true
      this.$store.dispatch('vendor/getvendors', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch () {
      this.visible = true
      this.fetchList()
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
